import { render, staticRenderFns } from "./ReviewDependents.vue?vue&type=template&id=b3d9cefa&scoped=true"
import script from "./ReviewDependents.vue?vue&type=script&lang=ts"
export * from "./ReviewDependents.vue?vue&type=script&lang=ts"
import style0 from "./ReviewDependents.vue?vue&type=style&index=0&id=b3d9cefa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3d9cefa",
  null
  
)

export default component.exports